<template>
  <layout>
    <div class="container mx-auto px-4 sm:px-6 lg:px-8">
      <div class="flex flex-col">
        <div class="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
          <!-- Page Header: start -->
          <div class="md:flex md:items-center md:justify-between">
            <div v-if="false" class="flex-1 min-w-0">
              <div class="-ml-2 -mt-2 flex flex-col sm:flex-row flex-wrap items-baseline">
                <h2 class="ml-2 mt-2 text-2xl leading-7 font-light text-gray-900">
                  Neue Social Graphic anlegen
                </h2>
                <p class="ml-2 mt-1 text-sm text-gray-500 truncate">
                  Vorlage &quot;{{ template.name }}&quot;
                </p>
              </div>
            </div>
            <div class="mt-4 flex md:mt-0 md:ml-4">

              <span v-if="false" class="sm:ml-3 shadow-sm rounded-md">
                <Link :href="route('social-graphics.index')"
                  class="inline-flex items-center px-4 py-2 border border-transparent text-sm leading-5 font-medium rounded-md text-gray-500 hover:text-white bg-gray-300 hover:bg-gray-400 focus:outline-none focus:ring-gray-500 focus:border-gray-400 active:bg-gray-400 transition duration-150 ease-in-out">
                Übersicht</Link>
              </span>
            </div>
          </div>
          <!-- Page Header: end -->

          <!-- <div
            class="absolute pointer-events-none w-[120px] h-[120px] bg-no-repeat bg-[200%] z-50 rounded-[50%] border-2 border-solid border-[#999]"
            ref="magnifier" v-show="showMagnifier" :style="magnifierStyle"></div> -->


          <horizontal-divider />

          

          <!-- <form @submit.prevent="submit" novalidate> -->
          <form novalidate>
            <div class="min-h-[700px]">
              <div class="md:grid md:grid-cols-3 md:gap-6">
                <div class="md:col-span-1 px-4 sm:px-0 relative">
                  <spinner :busy="svgBusy"></spinner>
                  <div class="template shadow-md absolute w-min" v-html="svg"></div>


                </div>
                <div class="mt-5 md:mt-0 md:col-span-2">

                  <!-- splitbutton: start -->
                  <!-- <div class="relative inline-block">
                    <div class="flex shadow-sm">
                      <button
                       :disabled="busy" @click="store"
                        class="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-l-md text-white bg-brandhelfer-green shadow-sm hover:bg-brandhelfer-green hover:text-white focus:outline-none  border-r border-r-gray-200"
                        onclick="alert('Default action')">
                        Speichern
                      </button>

                      <button
                      type="button"
                       :disabled="busy" @click="toggleButtonMenu"
                        class="inline-flex items-center px-2 py-2 border border-transparent text-sm font-medium rounded-r-md text-white bg-brandhelfer-green shadow-sm hover:bg-brandhelfer-green hover:text-white focus:outline-none  "
                        >
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
                          <path fill-rule="evenodd"
                            d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                            clip-rule="evenodd" />
                        </svg>
                      </button>
                    </div>

                    <div v-if="showButtonMenu"
                    id="text123"
                      class="absolute right-0 mt-1 w-fit bg-white rounded-md shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                      <div class="py-1" role="menu" aria-orientation="vertical" aria-labelledby="dropdown-button">
                        <a href="#" class="whitespace-nowrap block px-2 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900"
                          onclick="alert('Secondary action 1')">
                          Als PNG mit Transparenz Speichern
                        </a>
                      </div>
                    </div>
                  </div> -->
                  <!-- splitbutton: end -->

                  <button :disabled="busy" @click="store"
                    class="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-brandhelfer-green shadow-sm hover:bg-brandhelfer-green hover:text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brandhelfer-green">
                    Speichern
                  </button>

                  <horizontal-divider />

                  <div class="flex flex-row">
                    <div class="w-1/5">
                      <div v-if="hasBackgroundImage">
                        <i @click="activeSection = 'background-image'"
                          class="fa fa-fw fa-lg fa-image mb-4 cursor-pointer hover:text-brandhelfer-green" :class="activeSection == 'background-image'
                            ? 'text-brandhelfer-green'
                            : ''
                            "></i>
                      </div>

                      <div v-if="hasBackgroundColors">
                        <i @click="activeSection = 'background-color'"
                          class="fa fa-fw fa-lg fa-paint-brush mb-4 cursor-pointer hover:text-brandhelfer-green" :class="activeSection == 'background-color'
                            ? 'text-brandhelfer-green'
                            : ''
                            "></i>
                      </div>

                      <div v-if="hasTexts">
                        <i @click="activeSection = 'text'"
                          class="fa fa-fw fa-lg fa-font mb-4 cursor-pointer hover:text-brandhelfer-green" :class="activeSection == 'text'
                            ? 'text-brandhelfer-green'
                            : ''
                            "></i>
                      </div>

                      <div v-if="hasLayers">
                        <i @click="activeSection = 'layer'"
                          class="fa fa-fw fa-lg fa-object-ungroup mb-4 cursor-pointer hover:text-brandhelfer-green"
                          :class="activeSection == 'layer'
                            ? 'text-brandhelfer-green'
                            : ''
                            "></i>
                      </div>



                      <div v-if="hasExtraControls">
                        <i @click="activeSection = 'extras'"
                          class="fa fa-fw fa-lg fa-th-large mb-4 cursor-pointer hover:text-brandhelfer-green" :class="activeSection == 'extras'
                            ? 'text-brandhelfer-green'
                            : ''
                            "></i>
                      </div>
                    </div>

                    <div class="flex-grow">
                      <!-- Background Image -->
                      <div v-show="hasBackgroundImage &&
                        activeSection == 'background-image'
                        " class="flex flex-row w-full">
                        <background-image :backgroundImage="backgroundImage" :enabled="form.backgroundImageStatus"
                          @imageUploading="backgroundImageUploading"
                          @imageUploaded="backgroundImageUploaded" @statusToggled="backgroundImageStatusToggled">
                        </background-image>
                      </div>

                      <div class="flex-grow">
                        <!-- Background Image -->
                        <div v-show="hasBackgroundImage &&
                          usesBackgroundImageLibrary &&
                          activeSection == 'background-image'
                          " class="flex flex-row w-full">
                          <background-image-library :template="template" @imageSelected="backgroundImageSelected">
                          </background-image-library>
                        </div>
                      </div>


                      <!-- Layer -->
                      <transition name="fade">
                        <div v-show="hasLayers &&
                          activeSection == 'layer'
                          ">
                          <div class="flex flex-row w-full mb-4" v-for="layer in layers" :key="layer.id">
                            <layer :template="template" :layer="layer" @layerSelected="layerSelected"
                              @statusToggled="layerStatusToggled" :enabled="form.layerStatus[layer.id] || false">
                            </layer>
                          </div>
                        </div>
                      </transition>


                      <!-- Background Color -->
                      <transition name="fade">
                        <div v-show="hasBackgroundColors &&
                          activeSection == 'background-color'
                          ">
                          <div class="flex flex-row w-full mb-4" v-for="backgroundColor in backgroundColors"
                            :key="backgroundColor.id">
                            <background-color :backgroundColor="{
                              ...backgroundColor,
                              color: form.backgroundColors[backgroundColor.id] ?? backgroundColor.defaultColor,
                              enabled: form.backgroundColorsStatus[backgroundColor.id] ?? backgroundColor.enabled
                            }"
                              @colorSelected="backgroundColorSelected"
                              @colorStatusToggled="backgroundColorStatusToggled"></background-color>
                          </div>
                        </div>
                      </transition>

                      <!-- Text -->
                      <transition name="fade">
                        <div v-show="hasTexts && activeSection == 'text'" class="w-full">
                          <div>Texte</div>

                          <div class="mt-6">
                            <div v-for="(text, idx) in texts" :key="`text${idx}`" class="flex flex-row w-full mb-6">
                              <textinput v-if="text.type == 'textinput'" :text="text" @textEntered="textEntered"
                                @textColorChanged="textColorChanged" @textStatusToggled="textStatusToggled"></textinput>

                              <textbox v-if="text.type == 'textbox'" :text="text" @textEntered="textboxTextEntered"
                                @textColorChanged="textColorChanged" @textStatusToggled="textStatusToggled">
                              </textbox>

                              <wysiwyg v-if="text.type == 'wysiwyg'" :text="text" @textEntered="textboxWysiwygEntered"
                                @textColorChanged="textColorChanged" @textStatusToggled="textStatusToggled">
                              </wysiwyg>

                              <selection v-if="text.type == 'selection'" :select="text" @optionSelected="optionSelected"
                                @selectColorChanged="selectColorChanged" @selectStatusToggled="selectStatusToggled">
                              </selection>


                              <display v-if="text.type == 'display'" :display="text"
                                @statusToggled="textStatusToggled" :enabled="form.textsStatus[text.id] ?? !!text.enabled">
                              </display>


                            </div>
                          </div>
                        </div>
                      </transition>





                      <!-- Extras -->
                      <transition name="fade">
                        <div v-show="hasExtraControls && activeSection == 'extras'" class="w-full">
                          <div class="mt-6">
                            <div v-if="hasApplicationTable" class="flex flex-row w-full mb-6">
                              <color :color="applicationTableField" @colorChanged="applicationTableColorChanged"
                                @statusToggled="applicationTableStatusToggled"></color>
                            </div>
                            <div v-for="(extra, idx) in extras" :key="`extra${idx}`" class="flex flex-row w-full mb-6">
                              <color v-if="extra.type == 'color'" :color="extra" @colorChanged="extraColorChanged"
                                @statusToggled="extraColorStatusToggled" @pickerRequested="startExtraColorPicker"
                                :picker-enabled="!extra.picker || form.backgroundImageStatus === true"
                                :picker-color="form.extraPickerColors[extra.id] || null"></color>

                              <display v-if="extra.type == 'display'" :display="extra"
                                @statusToggled="extraDisplayStatusToggled" :enabled="extra.enabled ? true : false">
                              </display>

                              <display-group v-if="extra.type == 'displayGroup'" :display="extra"
                                @statusToggled="extraDisplayStatusToggled"></display-group>
                            </div>
                          </div>
                        </div>
                      </transition>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>

    <pending-modal v-if="busy"></pending-modal>
  </layout>
</template>

<script>
import Layout from '@/Shared/Layout.vue';

import SubmitButton from '@/Shared/SubmitButton.vue';
import PendingModal from '@/Shared/PendingModal.vue';
import Spinner from '@/Shared/Spinner.vue';
import Toggle from '@/Shared/Toggle.vue';
import BackgroundColor from '@/Shared/Fields/BackgroundColor.vue';
import BackgroundImage from '@/Shared/Fields/BackgroundImage.vue';
import BackgroundImageLibrary from '@/Shared/Fields/BackgroundImageLibrary.vue';
import Layer from '@/Shared/Fields/Layer.vue';
import Textinput from '@/Shared/Fields/Textinput.vue';
import Textbox from '@/Shared/Fields/Textbox.vue';
import Wysiwyg from '@/Shared/Fields/Wysiwyg.vue';
import Selection from '@/Shared/Fields/Selection.vue';
import Color from '@/Shared/Fields/Color.vue';
import Display from '@/Shared/Fields/Display.vue';
import DisplayGroup from '@/Shared/Fields/DisplayGroup.vue';
import { SVG } from '@svgdotjs/svg.js';
import { splice, isEmpty } from 'lodash';
import { applyApplicationTableSettings, updateApplicationTable } from '@/utils/applicationTable';
import { startSvgColorPicker } from '@/utils/svgColorPicker';
import { syncBrandBackground } from '@/utils/brandBackground';
import { applyProductVariantColors, productVariantExtras, syncProductVariant } from '@/utils/productVariant';
import { syncAngledBanner } from '@/utils/angledBanner';

export default {
  metaInfo: function () {
    return { title: `Vorlage "${this.template.name}"` };
  },

  components: {
    Layout,

    SubmitButton,
    PendingModal,
    Spinner,
    Toggle,
    BackgroundColor,
    BackgroundImage,
    BackgroundImageLibrary,
    Layer,
    Textinput,
    Textbox,
    Wysiwyg,
    Selection,
    Color,
    Display,
    DisplayGroup,
  },

  props: {
    template: Object,
    svg: String,
    conf: Object,
  },

  created() {
    window.addEventListener('resize', this.resizeWindowHandler);
  },

  mounted() {
    if (this.conf.angledBanner) {
      document.fonts.ready.then(() => this.syncBanner());
    }

    this.applyApplicationTableSettings();
    this.syncBackground();

    // this.setupMagnifier();


    // it seems as if it is not easy to give fixed elements
    // a width of 100% of their parent. so for now we are using this
    // javascript workaround (which sometime is not working)
    window.focus();
    let w = 0;
    setTimeout(function () {
      w = document.querySelector('.template').parentNode.offsetWidth;
      // console.log(w);
      document.querySelector('.template').style.width = `${w}px`;
    }, 500);
    // 


    // SVG('#path319').fill('rgba(59,130,246,1)');
    // SVG('#path321').fill('rgba(224,0,52,1)');
    //   var draw = SVG().addTo('body').size(300, 300)
    //   var rect = draw.rect(100, 100).attr({ fill: '#f06' })
    //   var test = SVG('#test rect');
    //   test.fill('#000000');
    // console.log(document.head.querySelector('meta[name="csrf-token"]').content);
    // let svg = this.backgroundImages[0].svg;
    //         svg = svg.replace('%$%LINK%$%', 'dddd')
    //           .replace('%$%X%$%', 0)
    //           .replace('%$%Y%$%', 0)
    //           .replace('%$%WIDTH%$%', this.backgroundImages[0].width)
    //           .replace('%$%HEIGHT%$%', this.backgroundImages[0].height)
    //           .trim();
    //           console.log(svg);
    //         // SVG(`svg g.image0`).replace(svg);
  },

  destroyed() {
    window.removeEventListener('resize', this.resizeWindowHandler);
  },


  data() {
    return {
      busy: false,
      svgBusy: false,
      activeSection: 'background-image',
      showButtonMenu: true,

      // form: this.$inertia.form({
      form: {
        backgroundImage: null,
        backgroundImageStatus: false,
        backgroundColors: {},
        backgroundColorsStatus: {},
        texts: {},
        textsStatus: {},
        textsColors: {},
        selects: {},
        selectsStatus: {},
        selectsColors: {},
        extraColors: {},
        extraPickerColors: {},
        extraColorStatus: {},
        extraDisplayStatus: {},
        layerItems: {},
        layerStatus: {},
        applicationTableColor: null,
        applicationTableStatus: null,
      },

      // showMagnifier: false,
      // magnifierStyle: {
      //   top: '0px',
      //   left: '0px',
      //   backgroundPosition: '0px 0px',
      //   backgroundImage: '',
      // },
    };
  },

  watch: {
    // svg() {
    //   this.setupMagnifier();
    // },

    // form: {
    //   handler() {
    //     for (let i = 0; i < this.form.texts.length; i++) {
    //       // jquery original
    //       // $('svg .text' + text + ' text tspan')
    //       SVG(`svg .text${i} text tspan`).text(this.form.texts[i]);
    //     }
    //   },
    //   deep: true,
    // },
  },

  methods: {
    resizeWindowHandler(e) {
      let w = document.querySelector('.template').parentNode.offsetWidth;
      document.querySelector('.template').style.width = `${w}px`;
    },

    toggleButtonMenu() {
      this.showButtonMenu = !this.showButtonMenu;
    },

    backgroundImageUploading(status) {
      this.svgBusy = status;
    },

    backgroundImageUploaded(image) {
      // this.form.backgroundImage = image;
      this.$set(this.form, 'backgroundImage', image);
      this.form.backgroundImageStatus = true;

      this.disableBackgroundColor();
      this.syncBackground();
    },

    backgroundImageSelected(image) {
      this.svgBusy = true;
      // console.log(route('social-graphics.background-image-library.link', { template: this.template, image: image }));
      SVG(`#backgroundImage`)?.attr(
        'href',
        route('social-graphics.background-image-library.link', {
          template: this.template,
          image: image,
        })
      );
      this.form.backgroundImageStatus = true;
      this.$set(this.form, 'backgroundImage', SVG('#backgroundImage')?.attr('href'));
      this.disableBackgroundColor();
      this.syncBackground();

      this.svgBusy = false;
    },

    backgroundImageStatusToggled(status) {
      this.form.backgroundImageStatus = status;

      this.syncBackground();
    },

    backgroundColorSelected(element, color) {
      this.$set(this.form.backgroundColors, element.id, color);
      this.$set(this.form.backgroundColorsStatus, element.id, true);

      SVG(`#${element.id}`)?.fill(`rgba(${color},1)`);
      this.syncBackground();
    },

    backgroundColorStatusToggled(element, status) {
      this.$set(this.form.backgroundColorsStatus, element.id, status);

      this.syncBackground();
    },

    textEntered(element, text) {
      // console.log('textfield', element.id, text);
      this.$set(this.form.texts, element.id, text);

      // 'div' is for text that is placed on top of growing 
      // background shapes
      if (element.child == 'div') {
        document.getElementById(element.id).innerHTML = text;

        // tspan if we have multiple tspan
      } else if (element.child == 'tspan') {
        document.getElementById(element.id).innerHTML = text;
      } else {
        SVG(`#${element.id}`)?.find('tspan')?.text(text);
      }
    },

    textboxTextEntered(element, text) {
      // console.log('textbox', element.id, text);
      this.$set(this.form.texts, element.id, text);

      if (element.banner) {
        this.syncBanner();
        return;
      }

      document.getElementById(element.id).innerHTML = this.nl2br(text, true);
    },

    textboxWysiwygEntered(element, text) {
      const formatted = this.formatWysiwygContent(text);
      this.$set(this.form.texts, element.id, text);
      document.getElementById(element.id).innerHTML = formatted;
    },

    formatWysiwygContent(html) {
      if (!html) return '';

      // Convert bold tags to custom font span
      html = html.replace(/<(strong|b)>(.*?)<\/\1>/gi, `<span style="font-family: 'MyriadPro-Semibold', sans-serif;">$2</span>`);

      const container = document.createElement('div');
      container.innerHTML = html;
      const blocks = Array.from(container.children);

      // TipTap emits paragraphs while the SVG foreignObject needs inline
      // content with explicit line breaks.
      if (blocks.length && blocks.every(block => /^(P|DIV)$/.test(block.tagName))) {
        return blocks.map(block => block.innerHTML).join('<br>').trim();
      }

      return container.innerHTML.trim();
    },





    textColorChanged(element, color) {
      this.$set(this.form.textsColors, element.id, color);

      if (element.banner) {
        this.syncBanner();
        return;
      }

      // 'div' is for text that is placed on top of growing 
      // background shapes
      if (element.child == 'div') {
        document.getElementById(element.id).style.color = `rgba(${color},1)`;
      } else {
        SVG(`#${element.id}`)?.fill(`rgba(${color},1)`);
      }
    },

    textStatusToggled(element, status) {
      this.$set(this.form.textsStatus, element.id, status);

      if (element.banner) {
        this.syncBanner();
        return;
      }

      if (element.type === 'display') {
        if (status) {
          SVG(`#${element.id}`)?.show();
        } else {
          SVG(`#${element.id}`)?.hide();
        }

        return;
      }

      // Change to visibility because class hidden
      // when reactivated replaces inline-block etc.
      if (status) {
        // SVG(`#${element.id}`)?.show();
        SVG(`#${element.id}`)?.css('visibility', 'visible');
      } else {
        // SVG(`#${element.id}`)?.hide();
        SVG(`#${element.id}`)?.css('visibility', 'hidden');
      }
    },












    optionSelected(element, option) {
      this.$set(this.form.selects, element.id, option);

      SVG(`#${element.id}`)?.find('tspan')?.text(option);
    },

    selectColorChanged(element, color) {
      this.$set(this.form.selectsColors, element.id, color);

      SVG(`#${element.id}`)?.fill(`rgba(${color},1)`);
    },

    selectStatusToggled(element, status) {
      this.$set(this.form.selectsStatus, element.id, status);

      if (status) {
        SVG(`#${element.id}`)?.show();
      } else {
        SVG(`#${element.id}`)?.hide();
      }
    },

    extraColorChanged(element, color) {
      let targetId = element.id;

      if (element.colorTargetId) {
        targetId = element.colorTargetId;
      }
      // console.log(targetId);
      this.$set(this.form.extraColors, targetId, color);

      let opacity = 1;
      if (element.opacity) {
        opacity = element.opacity;
      }

      SVG(`#${targetId}`)?.fill(`rgba(${color},${opacity})`);
    },

    startExtraColorPicker(element) {
      startSvgColorPicker(element.picker, (color) => {
        this.$set(this.form.extraPickerColors, element.id, color);
        this.extraColorChanged(element, color);
      });
    },

    extraColorStatusToggled(element, status) {
      this.$set(this.form.extraColorStatus, element.id, status);

      if (status) {
        SVG(`#${element.id}`)?.show();
      } else {
        SVG(`#${element.id}`)?.hide();
      }

      this.syncBackground();
    },

    disableBackgroundColor() {
      const backgroundColor = this.conf.backgroundColors?.[0];

      if (backgroundColor) {
        this.$set(this.form.backgroundColorsStatus, backgroundColor.id, false);
      }
    },

    syncBackground() {
      this.syncBanner();
      if (!syncProductVariant(this.conf, this.form, this.template, route)) {
        syncBrandBackground(this.conf, this.form, this.template, route);
      }
    },

    syncBanner() {
      if (this.conf.angledBanner) {
        this.$set(this.form, 'bannerErrors', syncAngledBanner(this.conf, this.form));
      }
    },

    resetProductColors() {
      applyProductVariantColors(this.conf, this.form, this.extraColorChanged, this.textColorChanged);
    },

    extraDisplayStatusToggled(element, status) {
      
      this.$set(this.form.extraDisplayStatus, element.id, status);

      if (status) {
        SVG(`#${element.id}`)?.show();
      } else {
        SVG(`#${element.id}`)?.hide();
      }
    },

    applicationTableColorChanged(element, color) {
      this.$set(this.form, 'applicationTableColor', color);
      this.applyApplicationTableSettings();
    },

    applicationTableStatusToggled(element, status) {
      this.$set(this.form, 'applicationTableStatus', status);
      this.applyApplicationTableSettings();
    },

    applyApplicationTableSettings() {
      applyApplicationTableSettings(this.applicationTable, this.applicationTableSettings);
    },


    async layerSelected(layer, layerItem, applyDefaults = true) {
      this.svgBusy = true;

      console.log(layer);
      console.log(layerItem);
      // console.log(route('social-graphics.background-image-library.link', { template: this.template, image: image }));
      SVG(`#${layer}`)?.attr(
        'href',
        route('social-graphics.layers.image-link', {
          template: this.template,
          layer: layer,
          layerItem: layerItem
        })
      );
      SVG(`#${layer}`)?.removeClass('hidden');

      if (this.conf.productVariants?.sourceLayer === layer) {
        const productChanged = this.form.layerItems[layer] !== layerItem || !this.form.layerStatus[layer];
        this.$set(this.form.layerStatus, layer, true);
        this.$set(this.form.layerItems, layer, layerItem);

        if (applyDefaults && productChanged) {
          this.resetProductColors();
        }

        this.syncBackground();
        this.svgBusy = false;
        return;
      }

      await updateApplicationTable(this.template, this.applicationTable, layer, layerItem);
      this.applyApplicationTableSettings();

      this.$set(this.form.layerStatus, layer, true);
      this.$set(this.form.layerItems, layer, layerItem);

      this.svgBusy = false;
    },

    layerStatusToggled(layer, status, applyDefaults = true) {
      const statusChanged = this.form.layerStatus[layer.id] !== status;
      this.$set(this.form.layerStatus, layer.id, status);

      if (status) {
        SVG(`#${layer.id}`)?.removeClass('hidden');
      } else {
        SVG(`#${layer.id}`)?.addClass('hidden');
      }

      if (this.conf.productVariants?.sourceLayer === layer.id) {
        if (applyDefaults && statusChanged) {
          this.resetProductColors();
        }

        this.syncBackground();
      }
    },

    store() {
      this.syncBanner();

      if (Object.keys(this.form.bannerErrors || {}).length) {
        this.activeSection = 'text';
        return;
      }

      // let hiddenElements = SVG('div.template svg > .hidden');
      // let hiddenElements = SVG('div.template svg').find('.hidden');

      // console.log(hiddenElements);
      // return false;

      // if (hiddenElements !== null) {
      //   SVG('div.template svg > .hidden').remove();
      // }

      SVG('div.template svg').find('.hidden').remove();

      let svg = SVG('div.template svg').svg();
      // console.log(svg); return;
      // svg = svg.find('.hidden').remove();
      // svg = svg.svg();

      // svg.removeClass('hidden');

      this.busy = true;

      // window.axios
      //   .post(
      //     route('social-graphics.store'), {
      //       template: this.template.id,
      //     }
      //   )
      //   .then(() => {
      //     this.busy = false;
      //   })
      //   .catch((error) => {});

      this.$inertia
        .post(
          route('social-graphics.store', {
            template: this.template.id,
          }),
          {
            svg: svg,
            settings: this.settings,
            // texts: this.form.texts,
          },
          {
            preserveScroll: true,
            onSuccess: () => {
              this.busy = false;
            }
          }
        );
    },


    nl2br(str, is_xhtml) {
      if (typeof str === 'undefined' || str === null) {
        return '';
      }
      var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>';
      console.log(breakTag);
      return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
    },


    // setupMagnifier() {
    //   const svgContainer = this.$el.querySelector('.template');

    //   svgContainer.addEventListener('mousemove', (e) => {
    //     const rect = svgContainer.getBoundingClientRect();
    //     const x = e.clientX - rect.left;
    //     const y = e.clientY - rect.top;

    //     this.showMagnifier = true;

    //     this.magnifierStyle.top = `${e.clientY - 60}px`; // 60 = half of magnifier height
    //     this.magnifierStyle.left = `${e.clientX - 60}px`;

    //     this.magnifierStyle.backgroundPosition = `-${x * 2 - 60}px -${y * 2 - 60}px`;

    //     const svgEl = svgContainer.querySelector('svg');
    //     // console.log(svgEl);

    //     if (svgEl) {
    //       const svgString = new XMLSerializer().serializeToString(svgEl);
    //       const base64 = window.btoa(svgString);
    //       this.magnifierStyle.backgroundImage = `url('data:image/svg+xml;base64,${base64}')`;
    //     }
    //   });

    //   svgContainer.addEventListener('mouseleave', () => {
    //     this.showMagnifier = false;
    //   });
    // },

  },

  computed: {
    backgroundImage() {
      return this.conf.backgroundImage || null;
    },

    hasBackgroundImage() {
      return this.backgroundImage !== null;
    },

    usesBackgroundImageLibrary() {
      return this.conf.backgroundImage.library || false;
    },

    layers() {
      return this.conf.layers || [];
    },

    hasLayers() {
      return this.layers.length > 0;
    },

    applicationTable() {
      return this.conf.applicationTable || null;
    },

    backgroundColors() {
      // return this.conf.backgroundColors[0].colors || [];
      return this.conf.backgroundColors || [];
    },

    hasBackgroundColors() {
      return this.backgroundColors.length > 0;
    },

    texts() {
      return (this.conf.texts || []).map(text => text.banner ? {
        ...text,
        value: this.form.texts[text.id] ?? text.placeholder,
        color: this.form.textsColors[text.id] || text.defaultColor,
        enabled: this.form.textsStatus[text.id] ?? Boolean(text.enabled),
        layoutError: this.form.bannerErrors?.[text.id],
      } : text);
    },

    hasTexts() {
      return this.texts.length > 0;
    },

    extras() {
      return productVariantExtras(this.conf, this.form);
    },

    hasExtras() {
      return this.extras.length > 0;
    },

    hasApplicationTable() {
      return Boolean(this.applicationTable?.elementId);
    },

    hasExtraControls() {
      return this.hasExtras || this.hasApplicationTable;
    },

    applicationTableField() {
      return {
        ...this.applicationTable,
        id: this.applicationTable.elementId,
        name: this.applicationTable.name || 'Anwendungstabelle',
        color: this.applicationTableSettings.color,
        enabled: this.applicationTableSettings.status,
      };
    },

    applicationTableSettings() {
      return {
        color: this.form.applicationTableColor ?? this.applicationTable?.defaultColor ?? null,
        status: this.form.applicationTableStatus ?? Boolean(this.applicationTable?.enabled),
      };
    },


    settings() {
      const settings = {};

      // --- Background Image ---
      const bgImageFromForm = this.form?.backgroundImage || null;
      const bgImageStatusFromForm = this.form?.backgroundImageStatus !== undefined ? !!this.form?.backgroundImageStatus : false;

      settings.backgroundImage = {
        // image: bgImageFromForm ? bgImageFromForm.split('/').reverse()[0] : null,
        image: bgImageFromForm || null,
        status: bgImageStatusFromForm !== undefined ? bgImageStatusFromForm : false,
      };

      // --- Background Color ---
      const bgConf = this.conf.backgroundColors?.[0];
      const bgId = bgConf?.id;

      const bgColorFromConf = bgConf?.defaultColor || null;
      const bgColorFromForm = this.form?.backgroundColors?.[bgId];
      const bgStatusFromConf = bgConf?.enabled !== undefined ? !!bgConf.enabled : null;
      const bgStatusFromForm = this.form?.backgroundColorsStatus?.[bgId];

      settings.backgroundColor = {
        color: bgColorFromForm || bgColorFromConf || null,
        status: bgStatusFromForm !== undefined ? bgStatusFromForm : bgStatusFromConf
      };

      if (this.hasApplicationTable) {
        settings.applicationTable = this.applicationTableSettings;
      }

      // --- Texts ---
      settings.texts = {};

      (this.conf.texts || []).forEach(textConf => {
        const id = textConf.id;

        settings.texts[id] = {
          value: textConf.banner
            ? this.form?.texts?.[id] ?? textConf.placeholder ?? ''
            : this.form?.texts?.[id] || textConf.placeholder || '',
          color: this.form?.textsColors?.[id] || textConf.defaultColor || null,
          status: this.form?.textsStatus?.[id] ?? (textConf.type === 'display'
            ? Boolean(textConf.enabled)
            : true)
        };
      });

      // --- Extras ---
      settings.extras = {};

      this.extras.forEach(extra => {
        const id = extra.id;

        settings.extras[id] = {
          color: this.form?.extraColors?.[id] || extra.defaultColor || null,
          pickerColor: this.form?.extraPickerColors?.[id] || null,
          status: this.form?.extraColorStatus?.[id] ?? !!extra.enabled
        };
      });

      // --- Layers ---
      settings.layers = {};

      (this.conf.layers || []).forEach(layer => {
        const id = layer.id;

        settings.layers[id] = {
          status: this.form?.layerStatus?.[id] ?? !!layer.enabled,
          item: this.form?.layerItems?.[id] || null,
        };
      });

      return settings;
    },

  },
};
</script>

<style>
div.template svg {
  width: 100% !important;
  height: 100% !important;
}

/* .fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
} */
</style>
